import { render, staticRenderFns } from "./shanghaiPartner.vue?vue&type=template&id=611c2fe6&scoped=true&"
import script from "./shanghaiPartner.vue?vue&type=script&lang=js&"
export * from "./shanghaiPartner.vue?vue&type=script&lang=js&"
import style0 from "./shanghaiPartner.vue?vue&type=style&index=0&id=611c2fe6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c2fe6",
  null
  
)

export default component.exports